<div class="excel-panel__label">{{ 'cfg_excelPanel_subtitle' | translate }}</div>
<div class="excel-panel__content">
    <div class="excel-panel__dragula" dragula="EXCELFIELD">
      <button *ngFor="let field of applicationData.configuration.csv[0]; let i = index" [id]="'excelField-'+i" class="button--square button--accent--outline">{{ field }}</button>
    </div>
    <button class="text-button excel-panel__button" (click)="process()"><span class="text-button__icon icon icon-gear"></span><span class="text-button__label">{{ 'cfg_excelPanel_generate' | translate }}</span></button>
</div>

<app-modal id="modal-confirm-excel-process" width="640" [blocking]="true" #mcep>
  <p [innerHtml]="'cfg_import_confirmApply' | translate"></p>

  <div class="modal__buttons">
    <button class="button button--square" (click)='mcep.close()'>
      <span>{{ 'btn_cancel' | translate }}</span>
    </button>

    <button class="button button--square" (click)='processConfirm()'>
      <span>{{ 'btn_ok' | translate }}</span>
    </button>
  </div>
</app-modal>


<app-modal id="modal-excel-generation" width="640" [blocking]="true" #mcep>
  <p [innerHtml]="'cfg_generationInfo' | translate"></p>
  <p>{{ progress }}</p>
</app-modal>